module.exports = __webpack_public_path__ + "media/src/images/mails/68cce6-035a2fb8bba62893ebba4f2d3385c8f2.png";